import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './services/msalConfig';
import { CheckSSOUser } from './services/apiService';

const msalInstance = new PublicClientApplication(msalConfig);

async function startApp() {
  try {
    await msalInstance.initialize();

    const response = await msalInstance.handleRedirectPromise();
    if (response) {
      msalInstance.setActiveAccount(response.account);

      // Complete backend auth after redirect (e.g. iOS Safari)
      const email = response.account?.username;
      if (email && !localStorage.getItem("authToken")) {
        try {
          const ssoResponse = await CheckSSOUser(email);
          if (ssoResponse && ssoResponse.token) {
            localStorage.setItem("authToken", ssoResponse.token);
            localStorage.setItem("isAuthenticated", "true");
            localStorage.removeItem("ssoAccessDeniedEmail");
          } else {
            localStorage.setItem("ssoAccessDeniedEmail", email);
          }
        } catch (err) {
          console.error("SSO backend auth after redirect failed", err);
          localStorage.setItem("ssoAccessDeniedEmail", email);
        }
      }
    } else {
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0]);
      }
    }

  } catch (e) {
    console.error("MSAL initialization failed", e);
  }

  const rootElement = document.getElementById("root");
  if (rootElement) {
    ReactDOM.createRoot(rootElement).render(
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    );
  }
}

startApp();
